import React from 'react';
import { Helmet } from "react-helmet";

export default function ServiceTitanScheduler() {
  return (
    <Helmet>
      <script>
        {`
          (function(q,w,e,r,t,y,u){
            q[t]=q[t]||function(){(q[t].q = q[t].q || []).push(arguments)};
            q[t].l=1*new Date();
            y=w.createElement(e);
            u=w.getElementsByTagName(e)[0];
            y.async=true;
            y.src=r;
            u.parentNode.insertBefore(y,u);
            q[t]('init', '52573867-2c5f-4e14-9f5b-0f63e9bebac7');
          })(window, document, 'script', 'https://static.servicetitan.com/webscheduler/shim.js', 'STWidgetManager');
        `}
      </script>
    </Helmet>
  );
}
